import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isGame = location.pathname === "/game";

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/5">
      <div className="px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/7a396de9d4a51ca3342f9bdb460bfa21/efd74d9ca1c0839b36715e646624f840.png"
            alt="Incident Ladder Logo"
            className="h-8 w-auto object-contain"
          />
          <span className="font-mono font-bold text-white text-lg tracking-tight hidden sm:block">
            Incident<span className="text-[#00ff88]">Ladder</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors font-mono">
            Home
          </Link>
          <a href="#how-it-works" className="text-sm text-white/60 hover:text-white transition-colors font-mono">
            How It Works
          </a>
          <a href="#features" className="text-sm text-white/60 hover:text-white transition-colors font-mono">
            Features
          </a>
          <Link
            to="/game"
            className="px-5 py-2 bg-[#00ff88] text-[#0a0a0a] text-sm font-bold font-mono rounded-md hover:bg-[#00e07a] transition-colors whitespace-nowrap"
          >
            Play Now
          </Link>
        </div>

        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white/70 hover:text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-white/5 px-6 py-4 flex flex-col gap-4">
          <Link to="/" className="text-sm text-white/60 hover:text-white font-mono" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
          <a href="#how-it-works" className="text-sm text-white/60 hover:text-white font-mono" onClick={() => setMenuOpen(false)}>
            How It Works
          </a>
          <a href="#features" className="text-sm text-white/60 hover:text-white font-mono" onClick={() => setMenuOpen(false)}>
            Features
          </a>
          <Link
            to="/game"
            className="px-5 py-2 bg-[#00ff88] text-[#0a0a0a] text-sm font-bold font-mono rounded-md text-center whitespace-nowrap"
            onClick={() => setMenuOpen(false)}
          >
            Play Now
          </Link>
        </div>
      )}
    </nav>
  );
}
